<template>
  <div class="body">
        <p  class="font1" style="padding-top: 13vh;">白日依山尽，黄河入海流</p>
        <p  class="font1" style="padding-top: 1vh;">欲穷千里目，更上一层楼</p>
        <div style="width: 82%;margin: 0 auto;">
            <p class="font2" style="padding-top: 5vh;">2023年你的个人发展与成长：</p>
            <p class="font2" v-if="this.count!=0" style="padding-top: 1vh;"> <i class="fa fa-check"></i>完成了<a class="font3">{{ this.count }}</a>个认证培训项目学习</p>
            <p class="font2" v-if="this.count1!=0"> <i class="fa fa-check"></i>获得了<a class="font3">{{ this.count1 }}</a>个证书</p>
            <div>
                <p class="font2" v-if="this.course!==''"> <i class="fa fa-check"></i>完成了<a class="font3">{{ this.course }}</a>培训</p>
                <p class="font2" v-if="this.promote!==''"> <i class="fa fa-check"></i>顺利晋升为<a class="font3">{{ this.promote }}</a></p>
                <p class="font2" v-if="this.teacher!==''"> <i class="fa fa-check"></i>通过讲师认证，成为<a class="font3">{{ this.teacher }}</a></p>
            </div> 
            
        </div>
        <p class="font3" style="padding-top: 5vh;font-size: 20px;">鹰击天风壮，鹏飞海浪春</p>
  </div>
</template>

<script>
export default {
    props:['ReportData'],
    data(){
        return {
            activityArray:[],
            course:'',
            promote:'',
            teacher:'',
            count:0,
            count1:0,
        }
    },
    created(){
        const activityArray = JSON.parse(this.ReportData.activity2)
        const activityArray1 = JSON.parse(this.ReportData.activity)
        this.count=activityArray1.length
        activityArray.forEach(element => {
           if(element.name=='讲师评审'){
                this.teacher=element.certificate
           }else if(element.name=='晋升'){
                this.promote=element.certificate
           }else{
                this.course=element.name
           }
        });
        activityArray1.forEach(element => {
            if (element.certificate!=='无') {
                this.count1++
            }
        });
       
    }
}
</script>

<style scoped>
.body {
    background:url("../../assets/year23/bg3.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;  
    align-items: center;  
}
.font1 {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    margin: 0 auto;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 17px;
    font-weight: bold;
    color: #953b5d;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>